/**
 * What the Help drawer should show when it opens. The authenticated layout
 * owns the drawer's open state and the current intent; pages ask for Help
 * through `useCommandPalette().requestHelp(intent?)` (the Home setup banner's
 * "All steps" opens the index, the tutorial peek tab opens its page's
 * explanation video). Opening without an intent always lands on the index, so
 * reopening Help never resumes a tutorial the person already left. The
 * footer's Shortcuts opens the keyboard shortcuts list.
 */
export type HelpIntent = { view: 'index' } | { view: 'tutorial'; tutorialId: string } | { view: 'shortcuts' }

export const HELP_INDEX: HelpIntent = { view: 'index' }

/**
 * Coerces whatever a caller passed into a HelpIntent. `requestHelp` is easy to
 * wire straight into an `onClick`, which hands it a MouseEvent — that (or
 * anything else unrecognised) means "open the index".
 */
export function toHelpIntent(value: unknown): HelpIntent {
  if (value && typeof value === 'object' && 'view' in value) {
    const intent = value as { view?: unknown; tutorialId?: unknown }
    if (intent.view === 'tutorial' && typeof intent.tutorialId === 'string' && intent.tutorialId) {
      return { view: 'tutorial', tutorialId: intent.tutorialId }
    }
    if (intent.view === 'shortcuts') return { view: 'shortcuts' }
  }
  return { view: 'index' }
}
